<!--
 * @Author: 王枫叶
 * @Date: 2020-12-22 14:41:47
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-12-22 16:39:53
-->
<template>
  <div class="edit-video-box">
    <el-dialog title="解封操作" :visible.sync="dialogVisible" width="350px">
      <el-form :model="params" :rules="rules" ref="form" label-width="100">
       <el-form-item label="是否解除vip:" prop="dismissVip">
          <el-switch v-model="params.dismissVip"
           active-text="是"
           inactive-text="否"></el-switch>
        </el-form-item>
       <el-form-item label="原因:" prop="reason" v-if="this.params.dismissVip">
          <el-input type="textarea"  v-model="reason1">
          </el-input>
        </el-form-item>
       <el-form-item label="原因:" prop="reason"  v-if="!this.params.dismissVip">
          <el-input type="textarea"  v-model="reason2">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";

export default {
  data() {
    return {
      dialogVisible: false,
      reason1:' 您的会员特权已被取消，请遵守官方规则不再发广告，否则将永久封号！！',
      reason2:'您的账号已解封，请按照官方规定，否则将永久封号',
      params: {
        dismissVip:false,
        reason: '',
        enable:false,
        uid:''
      },
      rules: {
      }
    };
  },
  methods: {
    // 编辑
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.getUserLock();
        } else {
          return false;
        }
      });
    },
    getUserLock() {
      this.loading = true;
      const param=Object.assign({},this.params,{reason:this.params.dismissVip?this.reason1:this.reason2})
      API.getUserLock(param)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.$emit("handleList");
          } else {
            this.$message.error("操作失败");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 外层弹窗关闭
    handleClose() {
      this.dialogVisible = false;
    },
    open(data) {
      this.dialogVisible = true;
       this.params.uid=data.uid
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .el-select,
  .el-textarea,
  .el-select > .el-input,
  .el-input {
    width: 100%!important;
  }
}
.form_item {
  display: flex;
}
</style>
